module.exports = __webpack_public_path__ + "static/media/preLogin_img_2.90541e93.png";